import { BSON } from 'realm-web';

export const performAggregation = async (collection: any, pipeline: any[]): Promise<any[]> => {
  const data = await collection?.aggregate(pipeline);
  if (!data) {
    return [];
  }

  return BSON.EJSON.deserialize(data) as any[];
};
